import { render } from "./ViewJobVacancy.vue?vue&type=template&id=65c21a19&scoped=true"
import script from "./ViewJobVacancy.vue?vue&type=script&lang=js"
export * from "./ViewJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=65c21a19&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c21a19"]])

export default __exports__